var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrivfirst(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12C0.500001 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12C0.500001 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_134)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_134)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 35,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11H11V46H46V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 22.3021C25.7438 22.3021 25.2188 23.4542 25.2188 25.5834V26.4875H31.7812V25.5834C31.7812 23.4542 31.2563 22.3021 28.5 22.3021Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5007 33.0214C29.3866 33.0214 30.1048 32.3032 30.1048 31.4173C30.1048 30.5313 29.3866 29.8131 28.5007 29.8131C27.6147 29.8131 26.8965 30.5313 26.8965 31.4173C26.8965 32.3032 27.6147 33.0214 28.5007 33.0214Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5003 13.9167C20.4503 13.9167 13.917 20.45 13.917 28.5C13.917 36.55 20.4503 43.0834 28.5003 43.0834C36.5503 43.0834 43.0837 36.55 43.0837 28.5C43.0837 20.45 36.5503 13.9167 28.5003 13.9167ZM36.3462 32.1459C36.3462 35.3542 35.3545 36.3459 32.1462 36.3459H24.8545C21.6462 36.3459 20.6545 35.3542 20.6545 32.1459V30.6875C20.6545 28.1938 21.2524 27.0417 23.0316 26.6479V25.5834C23.0316 24.2271 23.0316 20.1146 28.5003 20.1146C33.9691 20.1146 33.9691 24.2271 33.9691 25.5834V26.6479C35.7482 27.0417 36.3462 28.1938 36.3462 30.6875V32.1459Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_134",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_134",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 48.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivfirst);
export default __webpack_public_path__ + "static/media/icon-privfirst.4085fc64a9768e91494f802c3805f4c4.svg";
export { ForwardRef as ReactComponent };